class BlurText extends window.BAO.CustomElement() {
  connectedCallback () {
    /* eslint-disable-next-line no-undef */
    if (Shopify.designMode) return

    super.connectedCallback()

    if (this.dataset.runInstant === 'true') {
      setTimeout(() => {
        this.setAttribute('animate', '')
      }, 500)
    } else {
      // eslint-disable-next-line compat/compat
      this.observer = new IntersectionObserver(this.onEntry.bind(this), {
        rootMargin: '-100px',
        threshold: 0,
      })
      // We need to observe the video element as the host element has display: contents on it. IntersectionObserver won't work on an element that is set to display: contents
      this.observer.observe(this)
    }
  }

  onEntry ([entry], observer) {
    if (!entry.isIntersecting) return

    this.setAttribute('animate', '')

    observer.unobserve(this)
  }
}

if (!customElements.get('blur-text')) {
  customElements.define('blur-text', BlurText)
}
